import React from 'react'
import Background from './element/background';
import Icon from './element/icon';

import PartTextImage from './part-text-image'
import PartGallery from './part-gallery'
import PartDownloads from './part-downloads'
import PartVideo from './part-video'
import PartMosaic from './part-mosaic'
import PartForm from './part-form'
import PartImage from './part-image'
import PartMap from './part-map'

import * as entities from './entities/entities';

export default function Parts(props) {
    let part = props.part;

    let template_name = '';
    let template_type = '';
    let template_class = '';
    let bg_color = '';
    let entity_parts = '';
    let part_buttons = part['buttons'] ? part['buttons'] : '';
    if (part['template'] !== 'empty') {
        switch (part['template']) {
            case 'neo-textimg':
                template_name = 'PartTextImage';
                template_class = 'part-text-image';
                template_type = part['text_featured'] && part['text_featured'] === 1 ? 'part-featured' : '';
                break;
            case 'neo-gallery':
                template_name = 'PartGallery';
                template_class = 'part-gallery';
                break;
            case 'neo-downloads':
                template_name = 'PartDownloads';
                template_class = 'part-downloads';
                break;
            case 'neo-video':
                template_name = 'PartVideo';
                template_class = `part-video ${part['layout']}`;
                break;
            case 'neo-entities':
                //Select the layout of the especial part-parteable
                let entity_name = part['entity'].toLowerCase();
                if (entity_name.includes(".")) {
                    entity_parts = entity_name.split(".");
                    entity_name = entity_parts[1];
                }
                template_name = part['layout'];
                template_class = `${entity_name}_${part['layout']}`;
                break;
            case 'neo-multiple':
                template_name = 'PartMosaic';
                template_class = 'part-mosaic';
                break;
            case 'neo-form':
                template_name = 'PartForm';
                template_class = 'part-form';
                break;
            case 'neo-image':
                template_name = 'PartImage';
                template_class = 'part-image';
                break;
            case 'neo-map':
                template_name = 'PartMap';
                template_class = 'part-map';
                break;
            default:
                template_name = 'PartTextImage';
                template_class = 'part-text-image';
                template_type = part['text_featured'] && part['text_featured'] === 1 ? 'part-featured' : '';
                break;
        }

        bg_color = part['bg_color'] !== '' ? `bg-${part['bg_color']}` : '';
        var block_type = '';
        if(part['block_layout'] !== 'full'){
            block_type = part['block_layout'];
        }
    }


    const components = {
        PartTextImage,
        PartGallery,
        PartDownloads,
        PartVideo,
        PartMosaic,
        PartForm,
        PartImage,
        PartMap,
        ...entities
    };
    let template_elm = React.createElement(components[template_name], {part, part_buttons});

    return (
        <div className={`block ${template_class} ${bg_color} ${block_type} ${template_type}`} id={part['anchor'] && part['anchor']}>
            { part['media'] && <Background part={part} /> }
            <div className="content ">
                { part['icon'] && <Icon media={part.media} /> }
                {
                    template_name && 
                        template_elm 
                }
            </div>
        </div>

    )
}
